import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=86d23dc8&scoped=true&"
import script from "./TagsComponent.vue?vue&type=script&lang=js&"
export * from "./TagsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TagsComponent.vue?vue&type=style&index=0&id=86d23dc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d23dc8",
  null
  
)

export default component.exports